import {useQuery} from '@tanstack/react-query';
import {rqCreateSearchRequest} from '@app/reactQuery/apis/rqHttpsUtils';
import {
  RQ_GET_ALL_EMPLOYEE_DETAILS_API,
  RQ_GET_FIELD_STRUCTURE_API,
  RQ_GET_FIELD_STRUCTURE_HIERARCHY_API,
} from '@app/reactQuery/apis/constants';

export const RQUseGetFieldStructureData = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_field_structure_data', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, divisionId} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_FIELD_STRUCTURE_API,
        null,
        certificate,
        {divisionId: divisionId},
        signal,
      );
    },
    ...options,
  });
};

export const RQUseGetAllEmployeeDetailsData = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_all_employee_details_data', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_ALL_EMPLOYEE_DETAILS_API,
        null,
        certificate,
        null,
        signal,
      );
    },
    ...options,
  });
};

export const RQUseGetFieldStructureHierarchyData = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_field_structure_hierarchy_data', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_FIELD_STRUCTURE_HIERARCHY_API,
        null,
        certificate,
        null,
        signal,
      );
    },
    ...options,
  });
};
